import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const ProfileSection = () => {
  const [form, setForm] = useState({
    name: "",
    contact: "",
    email: "",
    password: "",
    confirm_password: "",
  });
  const [initialForm, setInitialForm] = useState({});

  // useEffect(() => {
  //   api.get("admin/profile/").then((res) => {
  //     setForm({
  //       ...form,
  //       name: res.data.name,
  //       contact: res.data.contact || "",
  //       email: res.data.email,
  //     });
  //   });
  // }, []);
  useEffect(() => {
  api.get("companyblog/admin/profile/").then((res) => {
    const data = {
      name: res.data.name,
      contact: res.data.contact || "",
      email: res.data.email,
      password: "",
      confirm_password: "",
    };

    setForm(data);
    setInitialForm(data);
  });
}, []);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {};

  // Send only changed profile fields
  ["name", "contact", "email"].forEach((key) => {
    if (form[key] !== initialForm[key]) {
      payload[key] = form[key];
    }
  });

  // Update profile only if something changed
  if (Object.keys(payload).length > 0) {
    await api.put("companyblog/admin/profile/", payload);
  }

  // Handle password change
  if (form.password || form.confirm_password) {
    if (!form.password || !form.confirm_password) {
      alert("Please fill both password fields");
      return;
    }

    await api.put("companyblog/admin/change-password/", {
      password: form.password,
      confirm_password: form.confirm_password,
    });

    // 🔥 Force logout after password change
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");

    window.location.href = "/admin_login";
    return;
  }

  alert("Profile updated successfully");
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Update profile info
  //   await api.put("admin/profile/", {
  //     name: form.name,
  //     contact: form.contact,
  //     email: form.email,
  //   });

  //   // Update password (optional)
  //   if (form.password && form.confirm_password) {
  //     await api.put("admin/change-password/", {
  //       password: form.password,
  //       confirm_password: form.confirm_password,
  //     });
  //   }

  //   alert("Profile updated successfully");
  //   setForm({ ...form, password: "", confirm_password: "" });
  // };

  return (
    <form onSubmit={handleSubmit} className="card p-4" style={{ maxWidth: 500 }}>
      <h4 className="mb-3">Profile</h4>

      <label>Name</label>
      <input
        className="form-control mb-3"
        name="name"
        value={form.name}
        onChange={handleChange}
      />

      <label>Contact</label>
      <input
        className="form-control mb-3"
        name="contact"
        value={form.contact}
        onChange={handleChange}
      />

      <label>Email</label>
      <input
        className="form-control mb-3"
        name="email"
        value={form.email}
        onChange={handleChange}
      />

      <label>Password</label>
      <input
        type="password"
        className="form-control mb-3"
        name="password"
        placeholder="Password"
        value={form.password}
        onChange={handleChange}
      />

      <label>Re-type Password</label>
      <input
        type="password"
        className="form-control mb-3"
        name="confirm_password"
        placeholder="Re-type Password"
        value={form.confirm_password}
        onChange={handleChange}
      />

      <button className="btn btn-primary me-2">Update</button>
    </form>
  );
};

export default ProfileSection;
